"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.ProductNameLink = exports.ProductName = exports.BrandNameLink = exports.BrandName = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(1)
}));
const brandNameStyles = (size, theme) => ({
  display: 'inline-flex',
  textDecoration: 'none',
  textTransform: 'uppercase',
  ...(size === 'small' ? {
    fontSize: '1rem',
    letterSpacing: '2px'
  } : {
    letterSpacing: '2.4px',
    [theme.breakpoints.up('sm')]: {
      letterSpacing: '3px'
    }
  })
});
const BrandName = exports.BrandName = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['size'])
})(({
  size,
  theme
}) => ({
  ...brandNameStyles(size, theme)
}));
const BrandNameLink = exports.BrandNameLink = (0, _mui.styled)(_mui.Link, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['size'])
})(({
  size,
  theme
}) => ({
  ...brandNameStyles(size, theme)
}));
const productNameStyles = {
  display: '-webkit-box',
  overflow: 'hidden',
  textDecorationLine: 'none',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
};
const ProductName = exports.ProductName = (0, _mui.styled)(_mui.Typography)({
  ...productNameStyles
});
const ProductNameLink = exports.ProductNameLink = (0, _mui.styled)(_mui.Link)({
  ...productNameStyles,
  textDecorationLine: 'underline',
  '&:hover': {
    color: undefined
  }
});
//# sourceMappingURL=styles.js.map